"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleTransactionResult = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const internal_1 = require("./internal");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
/**
 * This hook creates a callback to handle the payment transaction result.
 */
const useHandleTransactionResult = (props) => {
    const { paymentClient, authState } = props;
    const [error, setError] = (0, react_1.useState)();
    const getCustomerToken = (0, internal_1.useGetCustomerAccessToken)({ authState });
    const handleTransactionResult = (0, react_1.useCallback)((gatewayType, request) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const accessToken = yield getCustomerToken();
            const response = yield paymentClient.handleTransactionResult(gatewayType, request, {
                accessToken
            });
            setError(undefined);
            return response;
        }
        catch (error) {
            if (axios_1.default.isCancel(error)) {
                // do nothing if cancelled
                return;
            }
            if (axios_1.default.isAxiosError(error)) {
                setError((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
            }
            else {
                setError(error);
            }
            return;
        }
    }), [paymentClient, getCustomerToken]);
    return { handleTransactionResult, error };
};
exports.useHandleTransactionResult = useHandleTransactionResult;
//# sourceMappingURL=use-handle-transaction-result.js.map